import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  selector: 'automata-archive-sales-order',
  templateUrl: './archive-sales-order-panel.component.html',
  styleUrls: ['./archive-sales-order-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class ArchiveSalesOrderPanelComponent extends CommonActionPanelComponent implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();
    // Since there's nothing asynchronous about this form, saving is enabled on initialization.
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    return {};
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
